import React, { Component } from 'react';
import { connect } from 'react-redux';
import api from '../../axios-local-api';
import Spinner from '../../components/UI/Spinner/Spinner';
import {
  Last24HoursTimeline,
  Last30DaysTimeline,
  Last7DaysTimeline,
} from '../../components/UI/Timeline/Timeline';
import Box from '../../hoc/Box/Box';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../store/actions/index';
import classes from './WifiHealth.css';
import SelectDropdown from '../../shared/SelectDropdown/SelectDropdown';

export class WifiHealth extends Component {
  constructor(props) {
    super(props);
    var handleTopo = sessionStorage.getItem('handleTopology');
    this.state = {
      handleTopology: handleTopo,
      isTM: sessionStorage.getItem('techMobile'),
      days: this.props.days,
      maxDays: this.props.maxDays,
      timelineEndTime: new Date(),
      daysOptions: [
        { value: '1', label: 'Last 24 Hours' },
        { value: '7', label: 'Last 7 Days'},
        { value: '30', label: 'Last 30 Days'},
      ],
    };
    this.dayHandler = this.dayHandler.bind(this);
  }

  componentDidMount() {
    let dayCount = 1;
    if (this.state.isTM === true || this.state.isTM === 'true') {
      if (this.state.handleTopology.includes('default1TM')) {
        dayCount = 1;
      } else if (this.state.handleTopology.includes('default7TM')) {
        dayCount = 7;
      } else if (this.state.handleTopology.includes('default30TM')) {
        dayCount = 30;
      }
    } else {
      if (this.state.handleTopology.includes('default1GW')) {
        dayCount = 1;
      } else if (this.state.handleTopology.includes('default7GW')) {
        dayCount = 7;
      } else if (this.state.handleTopology.includes('default30GW')) {
        dayCount = 30;
      }
    }
    this.setState({
      days: dayCount,
    });
    if (!this.props.topologyLoaded) {
      this.props.onInitTopology(dayCount);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.wanLoading !== this.props.wanLoading) {
      this.setState({
        days: 7,
      });
    }
  }

  componentWillUpdate() { }
  componentDidUpdate() {
    if (this.state.maxDays !== this.props.maxDays) {
      this.setState({
        maxDays: this.props.maxDays,
      });
    }
  }

  refreshWifiHealthHandler = () => {
    this.modalCancelHandler();
  };
  dayHandler(e) {
    let days = parseInt(e.value, 10);
    console.info(
      '[' + new Date() + ']',
      '[INFO-UI]',
      '[ user= ' + sessionStorage.getItem('userId') + ']',
      '[ mac= ' + sessionStorage.getItem('mac') + ']',
      '[ message= user changed router health day value to ' + days + ']'
    );
    if (this.state.maxDays < days) {
      this.props.onInitTopology(days);
      this.setState({
        days: days,
      });
    } else {
      this.setState({
        days: days,
      });
    }
  }

  findEvents(
    realTopology,
    timelineStartTime,
    timelineEndTime,
    wanConnectionState
  ) {
    if (realTopology.length === 0) {
      return [];
    }
    var events = realTopology.filter((elem) => {
      if (!elem.topology) {
        return false;
      }
      var state = elem.topology[0].connectionState;
      if (state === undefined || state === '') {
        return false;
      }

      if (state === 'connected' || state === 'disconnected') {
        return true;
      } else {
        return false;
      }
    });

    if (events.length === 0) {
      return [];
    }

    if (events[0].timestamp < timelineStartTime.getTime()) {
      var event = events[0];
      var newEvent = JSON.parse(JSON.stringify(events[0]));
      newEvent.timestamp = timelineStartTime.getTime();
      events[0] = newEvent;
    }
    for (var i = 0; i < events.length; i++) {
      events[i].startTime = new Date(events[i].timestamp);
      var eventColor =
        events[i].topology[0].connectionState === 'connected' ? 'green' : 'red';
      events[i].class = eventColor;
      if (i + 1 === events.length) {
        break;
      }
      events[i].endTime = new Date(events[i + 1].timestamp);
    }
    var lastevent = events.find((e) => {
      return e.endTime === undefined;
    });
    if (lastevent !== undefined) {
      lastevent.endTime = timelineEndTime;
      lastevent.class = wanConnectionState === 'connected' ? 'green' : 'red';
    }
    return events;
  }
  getUptimeAndOutageValues(connectedEvents, disconnectedEvents) {
    var upTimes = connectedEvents.map(
      (e) => e.endTime.getTime() - e.startTime.getTime()
    );
    var totalUpTime = upTimes.reduce((sum, t) => sum + t, 0);
    var outageTimes = disconnectedEvents.map(
      (e) => e.endTime.getTime() - e.startTime.getTime()
    );
    var totalOutageTime = outageTimes.reduce((sum, t) => sum + t, 0);
    var uptimePercentage =
      totalUpTime === 0 && totalOutageTime === 0
        ? 100
        : ((totalUpTime / (totalUpTime + totalOutageTime)) * 100).toFixed(2);
    var totalOutageTimeInMins = (totalOutageTime / (1000 * 60)).toFixed(0);
    var totalOutageTimeInHours = (totalOutageTimeInMins / 60).toFixed(0);
    var totalOutageTimeValue = '';
    if (totalOutageTimeInHours > 1) {
      totalOutageTimeValue = totalOutageTimeInHours + ' hrs';
    } else {
      totalOutageTimeValue = totalOutageTimeInMins + ' mins';
    }
    return {
      outageTimeValue: totalOutageTimeValue,
      uptimePercentage: uptimePercentage + ' %',
    };
  }
  filterTopologyByDays(topology, startTime, endTime, wanConnectionState) {
    if (topology.length === 0) {
    }
    //Sometimes the topology service returns events in reverse order
    topology.sort((e1, e2) => {
      return e1.timestamp - e2.timestamp;
    });

    var topologyByDays = topology.filter((t) => {
      if (t === undefined || t.timestamp === undefined) {
        return false;
      }

      return (
        t.timestamp >= startTime.getTime() && t.timestamp <= endTime.getTime()
      );
    });
    if (topologyByDays.length === 0) {
      return [
        {
          timestamp: startTime.getTime(),
          topology: [
            {
              connectionState: wanConnectionState,
            },
          ],
        },
      ];
    }
    var events = topology.filter(
      (t) => t.timestamp < topologyByDays[0].timestamp
    );
    if (events.length > 0) {
      var event = events[events.length - 1];

      topologyByDays.unshift(event);
    } else {
    }
    //sometimes there are no events in btw last event and timeline endTime. So in order to fill the gap, we created an event with WAN connectionState.
    var lastevent = topologyByDays[topologyByDays.length - 1];
    if (lastevent.timestamp < endTime) {
      lastevent.topology = [
        {
          connectionState: wanConnectionState,
        },
      ];
    }
    return topologyByDays;
  }

  render() {
    var daysSelect = (
      <SelectDropdown
      disabled={true}
      aria-label="days"
      height={'30px'}
      width={'150px'}
      name="wifiHealth"
      defaultValue={[
        { value: '1', label: 'Last 24 Hours' },
      ]}
      options={[
        { value: '1', label: 'Last 24 Hours' },
      ]}
      isSearchable={false}
      onChange={(e) => {
        this.dayHandler(e)}}
    />
    );
    if (this.state.isTM === true || this.state.isTM === 'true') {
      if (
        this.state.handleTopology &&
        this.state.handleTopology.includes('max7DaysTM')
      ) {
        daysSelect = (
          <SelectDropdown
            disabled={true}
            aria-label="days"
            height={'30px'}
            width={'150px'}
            name="wifiHealth"
            defaultValue={[
              { value: '1', label: 'Last 24 Hours' },
            ]}
            options={[
              { value: '1', label: 'Last 24 Hours' },
              { value: '7', label: 'Last 7 Days'},
            ]}
            isSearchable={false}
            onChange={(e) => {
              this.dayHandler(e)}}
          />
        );
      } else if (
        this.state.handleTopology &&
        this.state.handleTopology.includes('max30DaysTM')
      ) {
        daysSelect = (
          <SelectDropdown
            disabled={true}
            aria-label="days"
            height={'30px'}
            width={'150px'}
            name="wifiHealth"
            defaultValue={this.state.daysOptions.filter(option => option.value == this.state.days)}
            options={this.state.daysOptions}
            isSearchable={false}
            onChange={(e) => {
              this.dayHandler(e)}}
          />
        );
      }
    } else {
      if (
        this.state.handleTopology &&
        this.state.handleTopology.includes('max7DaysGW')
      ) {
        daysSelect = (
          <SelectDropdown
            disabled={true}
            aria-label="days"
            height={'30px'}
            width={'150px'}
            name="wifiHealth"
            defaultValue={[
              { value: '1', label: 'Last 24 Hours' },
            ]}
            options={[
              { value: '1', label: 'Last 24 Hours' },
              { value: '7', label: 'Last 7 Days'},
            ]}
            isSearchable={false}
            onChange={(e) => {
              this.dayHandler(e)}}
          />
        );
      } else if (
        this.state.handleTopology &&
        this.state.handleTopology.includes('max30DaysGW')
      ) {
        daysSelect = (
          <SelectDropdown
            disabled={true}
            aria-label="days"
            height={'30px'}
            width={'150px'}
            name="wifiHealth"
            defaultValue={this.state.daysOptions.filter(option => option.value == this.state.days)}
            options={this.state.daysOptions}
            isSearchable={false}
            onChange={(e) => {
              this.dayHandler(e)}}
          />
        );
      }
    }

    var TimelineTag = null;
    if (this.state.days === 7) {
      TimelineTag = Last7DaysTimeline;
    } else if (this.state.days === 30) {
      TimelineTag = Last30DaysTimeline;
    } else if (this.state.days === 1) {
      TimelineTag = Last24HoursTimeline;
    }
    if (
      this.props.topologyLoading ||
      !this.props.topologyLoaded ||
      this.props.wanLoading ||
      !this.props.wanLoaded
    ) {
      return <Spinner />;
    } else if (
      !this.props.realTopology ||
      this.props.realTopology === 'null' ||
      this.props.realTopology.length === 0 ||
      1 === 0
    ) {
      return (
        <Box>
          <div className={classes.WifiHealth}>
            <div className={classes.TitleArea}>
              <div className={classes.TitleLeft}>
                <h3 title='Showing the connection status of the Router. Changes to status reflected here are exclusive to the Router.' style={{ paddingRight: 20, cursor: 'pointer' }}>Router Health</h3>

                <SelectDropdown
                  disabled={true}
                  height={'30px'}
                  width={'150px'}
                  name="wifiHealth"
                  defaultValue={[
                    { value: '1', label: 'Last 24 Hours' },
                  ]}
                  options={[
                    { value: '1', label: 'Last 24 Hours' },
                  ]}
                  isSearchable={false}
                  onChange={(e) => {
                    this.dayHandler(e)}}
                />
              </div>

              <div className={classes.TitleRight}>
                <p style={{ paddingLeft: 20, color: '#595959' }}>Up Time:</p>

                <p id="notavail" style={{ color: '#ccc' }}>
                  N/A
                </p>

                <p style={{ paddingLeft: 20, color: '#595959' }}>Outage:</p>

                <p id="notavail" style={{ color: '#ccc' }}>
                  N/A
                </p>
              </div>
            </div>

            <div className={classes.Separator} />

            <div className={classes.BodyArea}>
              <div id="noWifihealth" style={{ color: 'gray', padding: '20px' }}>
                There is no Router Health Information available at this time
              </div>
            </div>
          </div>
        </Box>
      );
    } else {
      let nowTime = new Date();

      let tfh = 24 * 60 * 60 * 1000;

      var claimedDate = new Date(this.props.realWan.claimedAt);

      var claimedTime = claimedDate.getTime();

      let daysAmount = new Date(nowTime.getTime() - this.state.days * tfh);

      let dayArray = [];

      for (let i = 1; i <= this.state.days; i++) {
        let startTime = nowTime * (i - tfh * i);

        let endTime = nowTime * (i - tfh * i);

        let period = {
          startTime: startTime,

          endTime: endTime,
        };

        dayArray.push(period);
      }
      var timelineStartTime = new Date(
        this.state.timelineEndTime.getTime() -
        this.state.days * 24 * 60 * 60 * 1000
      );

      var topology = this.filterTopologyByDays(
        this.props.realTopology,
        timelineStartTime,
        this.state.timelineEndTime,
        this.props.realWan.connectionState
      );
      var events = this.findEvents(
        topology,
        timelineStartTime,
        this.state.timelineEndTime,
        this.props.realWan.connectionState
      );
      let connectedEvents = events.filter((elem) => {
        return elem.topology
          ? elem.topology[0].connectionState === 'connected'
          : false;
      });

      let disconnectedEvents = events.filter((elem) => {
        return elem.topology
          ? elem.topology[0].connectionState === 'disconnected'
          : false;
      });
      var uptimeAndOutage;
      if (events.length === 0) {
        if (this.props.realWan.connectionState === 'disconnected') {
          uptimeAndOutage = {
            outageTimeValue: this.state.days * 24 + ' hrs',
            uptimePercentage: '0 %',
          };
        } else {
          uptimeAndOutage = {
            outageTimeValue: '0 hrs',
            uptimePercentage: '100 %',
          };
        }
      } else {
        uptimeAndOutage = this.getUptimeAndOutageValues(
          connectedEvents,
          disconnectedEvents
        );
      }

      var connectionStartTime;
      if (this.props.realWan !== undefined && this.props.realWan != null) {
        connectionStartTime = new Date(this.props.realWan.claimedAt);
      } else {
        connectionStartTime = connectedEvents[0].startTime;
      }
      var timelineData;
      if (
        events.length === 0 &&
        this.props.realWan.connectionState === 'disconnected'
      ) {
        timelineData = {
          connectionStartTime: connectionStartTime,
        };
      } else {
        timelineData = {
          connectionStartTime: connectionStartTime,
          events: connectedEvents.concat(disconnectedEvents),
          endTime: this.state.timelineEndTime,
        };
      }
      if (dayArray.length === parseInt(this.state.days, 10)) {
        let greenBars = dayArray.map((element, ind, arr) => {
          return (
            <div
              key={ind}
              className={classes.GreenBar}
              style={
                this.props.realTopology.fake && this.props.isDummy
                  ? { backgroundColor: 'pink' }
                  : { backgroundColor: 'green' }
              }
            >
              <div
                className={classes.GreenBarFiller}
                style={
                  this.props.realTopology.fake && this.props.isDummy
                    ? { backgroundColor: 'pink' }
                    : { backgroundColor: 'green' }
                }
              />
            </div>
          );
        });

        return (
          <Box>
            <div className={classes.WifiHealth}>
              <div className={classes.TitleArea}>
                <div className={classes.TitleLeft}>
                  <h3 title='Showing the connection status of the Router. Changes to status reflected here are exclusive to the Router.' style={{ paddingRight: 20, cursor: 'pointer' }}>Router Health</h3>
                  {daysSelect}
                </div>
                <div className={classes.TitleRight}>
                  <p id="uptime" style={{ paddingLeft: 20, color: '#595959' }}>
                    {' '}
                    Up Time:
                  </p>
                  <p
                    id="UptimePerc"
                    style={
                      this.props.realTopology.fake && this.props.isDummy
                        ? { color: 'pink' }
                        : { color: '#0073d1' }
                    }
                  >
                    {uptimeAndOutage.uptimePercentage}
                  </p>
                  <p id="outage" style={{ paddingLeft: 20, color: '#595959' }}>
                    Outage:
                  </p>
                  <p
                    id="OutagetimePerc"
                    style={
                      this.props.realTopology.fake && this.props.isDummy
                        ? { color: 'pink' }
                        : { color: '#0073d1' }
                    }
                  >
                    {uptimeAndOutage.outageTimeValue}
                  </p>
                </div>
              </div>
              <div className={classes.Separator} />
              <div className={classes.BodyArea}>
                <TimelineTag data={timelineData} />
              </div>
            </div>
          </Box>
        );
      } else {
        return (
          <div style={{ marginTop: '30vh' }}>
            <Spinner />
          </div>
        );
      }
    }
  }
}
const mapStateToProps = (state) => {
  return {
    topologyLoading: state.topology.loading,
    topologyLoaded: state.topology.loaded,
    wanLoading: state.wan.loading,
    wanLoaded: state.wan.loaded,
    account: state.settings.account,
    isAuthenticated: state.auth.token !== null,
    isPinxt: state.auth.pToken !== null,
    realTopology: state.topology.realTopology,
    isDummy: state.auth.isDummy,
    days: state.topology.days,
    maxDays: state.topology.maxDays,
    realWan: state.wan.realWan,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onInitTopology: (days) => dispatch(actions.initTopology(days)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(WifiHealth, api));
